import React from 'react';
import styles from './Footer.css';

const Footer = () => (
  <footer className={styles.Footer}>
    <p>Copyright &copy; 2020 CovrLettr</p>
  </footer>
);

export default Footer;
